import { render, staticRenderFns } from "./SystemTickets.vue?vue&type=template&id=264c3dfa&"
import script from "./SystemTickets.vue?vue&type=script&lang=js&"
export * from "./SystemTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports